import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";

import {
  Screen1,
  Questions,
  Details,
  Target,
  Get,
  Speaker,
  Advance,
  Reg
} from "../../../components/LandingTemplates/kak_nauchit_rebenka_chitat_web_ndch";

const TITLE = 'Как помочь ребёнку с обучением в начальной школе - бесплатный вебинар Адванс';
const DESCRIPTION = 'Бесплатный вебинар поможет с обучением в начальной школе. Занятие для педагогов, родителей и детей от 6 до 10 лет.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'747defaf101abbf0f98e8c47644d6567c1ab4e09'} id={'134295'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'ndch'}/>
      <Questions/>
      <Details/>
      <Target/>
      <Get/>
      <Speaker/>
      <Advance/>
      <Reg id={'ndch'} widget={widget}/>
    </main>

    <FooterFull/>

  </DefaultLayout>
);
export default Page;
